import { Configurer } from '../Core/index';
import { Sms_ovh } from './Sms_ovh';

/**SMS sender, to send text messages to mobile phones.This SMS sending service uses the OVH API.*/
export class Sms_ovhConfigurer extends Configurer {}
